import { ApiError } from "./errors";

type RawSuccess<T> = { status?: number; data?: { status: "SUCCESS"; data: T } };
type RawError = {
  code: string | undefined;
  message: string | undefined;
  status?: number;
  data?: { status: "ERROR"; message?: string; code?: string };
  response?: {
    data?: {
      error?: {
        code: string;
        details: string[];
        reason: string;
      };
    };
  };
};

export function unwrap<T>(raw: RawSuccess<T> | RawError): T {
  const ok =
    (raw as RawSuccess<T>)?.status === 200 && (raw as RawSuccess<T>)?.data?.status === "SUCCESS";
  if (!ok) {
    const msg =
      (raw as RawError)?.response?.data?.error?.reason ??
      (raw as RawError)?.message ??
      (raw as RawError)?.data?.message ??
      "Solicitud fallida";
    const code =
      (raw as RawError)?.response?.data?.error?.code ??
      (raw as RawError)?.code ??
      (raw as RawError)?.data?.code;
    const status = (raw as RawError)?.status;
    throw new ApiError(msg, { code, status });
  }
  const payload = (raw as RawSuccess<T>).data?.data;
  if (payload === undefined || payload === null) throw new ApiError("Sin datos");
  return payload as T;
}
